module.exports = __webpack_public_path__ + "img/horizontal_4_1_7042.3d0afb3e.png";